import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
export function WebinarFooter() {
  return <footer style={{
    background: '#080810',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '40px 16px 24px'
  }} data-id="element-116">
      <div style={{
      maxWidth: '1100px',
      margin: '0 auto'
    }} data-id="element-117">
        {/* Top row */}
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '20px',
        marginBottom: '28px'
      }} data-id="element-118">
          {/* Logo + tagline */}
          <div data-id="element-119">
            <div style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            fontSize: '22px',
            color: 'white',
            marginBottom: '6px',
            letterSpacing: '-0.01em'
          }} data-id="element-120">
              De Cero a Afiliado
            </div>
            <p style={{
            color: '#6b6b80',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-121">
              Tu camino al éxito en TikTok Shop
            </p>
          </div>

          {/* Links */}
          <div style={{
          display: 'flex',
          gap: '24px',
          flexWrap: 'wrap'
        }} data-id="element-122">
            {['Privacidad', 'Términos', 'Contacto'].map(link => <a key={link} href="#" style={{
            color: '#6b6b80',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif',
            textDecoration: 'none',
            transition: 'color 0.2s'
          }} onMouseEnter={e => e.currentTarget.style.color = 'var(--color-teal)'} onMouseLeave={e => e.currentTarget.style.color = '#6b6b80'} data-id="element-123">
                {link}
              </a>)}
          </div>

          {/* Social icons */}
          <div style={{
          display: 'flex',
          gap: '12px'
        }} data-id="element-124">
            <a href="#" style={{
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#a0a0b0',
            textDecoration: 'none',
            fontSize: '16px',
            transition: 'border-color 0.2s, background 0.2s'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'rgba(24,163,159,0.45)';
            e.currentTarget.style.background = 'rgba(24,163,159,0.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
            e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
          }} aria-label="TikTok" data-id="element-125">
              🎵
            </a>
            <a href="#" style={{
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#a0a0b0',
            textDecoration: 'none',
            transition: 'border-color 0.2s, background 0.2s'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'rgba(242,42,114,0.45)';
            e.currentTarget.style.background = 'rgba(242,42,114,0.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
            e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
          }} aria-label="Instagram" data-id="element-126">
              <InstagramIcon size={16} data-id="element-127" />
            </a>
            <a href="#" style={{
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#a0a0b0',
            textDecoration: 'none',
            transition: 'border-color 0.2s, background 0.2s'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'rgba(242,42,114,0.45)';
            e.currentTarget.style.background = 'rgba(242,42,114,0.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
            e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
          }} aria-label="YouTube" data-id="element-128">
              <YoutubeIcon size={16} data-id="element-129" />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div style={{
        height: '1px',
        background: 'rgba(255,255,255,0.06)',
        marginBottom: '20px'
      }} data-id="element-130" />

        {/* Bottom row */}
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px'
      }} data-id="element-131">
          <p style={{
          color: '#6b6b80',
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-132">
            © 2024 Ventas 6452. Todos los derechos reservados.
          </p>
          <p style={{
          color: '#4a4a5a',
          fontSize: '11px',
          fontFamily: 'Inter, sans-serif',
          maxWidth: '500px',
          textAlign: 'right',
          lineHeight: 1.5
        }} data-id="element-133">
            Los resultados mostrados no son típicos. Los ingresos dependen del
            esfuerzo individual.
          </p>
        </div>
      </div>
    </footer>;
}